import { ref } from 'vue'

/** 编辑器认证弹窗初始模式 */
export type EditorAuthDialogMode = 'login' | 'register'

const authDialogOpen = ref(false)
const authDialogMode = ref<EditorAuthDialogMode>('login')

/**
 * 跨组件共享的登录/注册弹窗状态（顶栏与首屏门控共用）。
 */
export function useEditorAuthDialog() {
  /**
   * @param mode - 打开时展示的 Tab
   */
  function openEditorAuthDialog(mode: EditorAuthDialogMode = 'login'): void {
    authDialogMode.value = mode
    authDialogOpen.value = true
  }

  /**
   * 程序化关闭弹窗（用户也可通过弹窗 UI 关闭）。
   */
  function closeEditorAuthDialog(): void {
    authDialogOpen.value = false
  }

  return {
    authDialogOpen,
    authDialogMode,
    openEditorAuthDialog,
    closeEditorAuthDialog,
  }
}
